import React, { useState, useEffect, useRef } from "react";
import RubricFrame from "../rubricFrame/RubricFrame";
import styles from "./FrameWrapperRubric.module.scss";
import IconClose from "../../common/icons/IconClose";
import RubricLoadingSkeleton from "./RubricLoadingSkeleton";

const FrameWrapperRubric = ({ rubric, type, closePopup, isPreview }) => {
  const [loading, setLoading] = useState(true);
  const containerRef = useRef(null);

  useEffect(() => {
    // Show skeleton until rubric data is available
    if (rubric) {
      const timer = setTimeout(() => {
        setLoading(false);
      }, 300); // Small delay to show skeleton
      
      return () => clearTimeout(timer);
    } else {
      setLoading(true);
    }
  }, [rubric]);

  useEffect(() => {
    const handleScroll = (e) => {
      const container = containerRef.current;
      if (!container) return;

      const { scrollTop, scrollHeight, clientHeight } = container;
      const isAtTop = scrollTop === 0;
      const isAtBottom = Math.ceil(scrollTop + clientHeight) >= scrollHeight;

      if ((isAtTop && e.deltaY < 0) || (isAtBottom && e.deltaY > 0)) {
        e.preventDefault();
      }
      e.stopPropagation();
    };

    const container = containerRef.current;
    if (container) {
      container.addEventListener("wheel", handleScroll, { passive: false });
      
      return () => {
        container.removeEventListener("wheel", handleScroll);
      };
    }
  }, []);

  if (loading) {
    return (
      <RubricLoadingSkeleton 
        closePopup={closePopup} 
        containerRef={containerRef} 
      />
    );
  }

  return (
    <>
      <div className={styles.modalBackdrop} onClick={closePopup} />
      <div className={styles.modalWrapper}>
        <RubricFrame rubric={rubric} type={type} isPreview={isPreview} />
        <div className={styles.closeIcon} onClick={closePopup}>
          <IconClose />
        </div>
      </div>
    </>
  );
};

export default FrameWrapperRubric;
